import { render, staticRenderFns } from "./LiberarAsientoModal.vue?vue&type=template&id=46de4155"
import script from "./LiberarAsientoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LiberarAsientoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports